import React, { useEffect, useState } from 'react'
import Header from '../../layouts/Header'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import axios from '../../api/axios';
import { toast } from 'react-toastify';
import ReusableTable from '../../components/ReusableTable';
import { PencilFill, TrashFill } from 'react-bootstrap-icons';
import makeAnimated from "react-select/animated";

const MenuAddons = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);

    const accessToken = localStorage.getItem("authToken");
    const animatedComponents = makeAnimated();
    const [page, setPage] = useState('1');
    const [limit, setLimit] = useState('10');
    const [totalPages, setTotalPages] = useState('')
    const [categoryId, setCategoryId] = useState('');
    const [categoryList, setCategoryList] = useState([]);
    const [productId, setProductId] = useState('');
    const [productsList, setProductsList] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [editedData, setEditedData] = useState({});
    const [selectedEditedExcludedOutlets, setSelectedEditedExcludedOutlets] = useState([]);
    const [selectedEditedValueExcludedOutlets, setSelectedEditedValueExcludedOutlets] = useState([]);
    const [inputData, setInputData] = useState({
        product: "",
        addonTitle: "",
        addonSerialNumber: "",
        isMultipleSelect: false,
        addonValues: [
          {
            value: "",
            mrp: "",
            offerPrice: "",
            sequenceNumber: "",
            icon: "",
            isDefault: false,
            subLabel: "",
            // status: "INACTIVE"
          },
        ],
    });
    const [validationErrors, setValidationErrors] = useState({
        product: "",
        addonTitle: "",
        addonSerialNumber: "",
        addonValues: [],
      });
    
    const [editValidationErrors, setEditValidationErrors] = useState({
        addonTitle: "",
        addonSerialNumber: "",
        value: "",
        mrp: "",
        offerPrice: "",
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [outlets, setOutlets] = useState([]);
    const [selectedExcludedOutlets, setSelectedExcludedOutlets] = useState([]);
    const [selectedValueExcludedOutlets, setSelectedValueExcludedOutlets] = useState([]);
    const [addNewOpenModal, setAddNewOpenModal] = useState(false);
    const [iconsList, setIconsList] = useState([]);
    const [addonProductsList, setAddonProductsList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [totalRows, setTotalRows] = useState('');
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [productAddonId, setProductAddonId] = useState('');
    const [openEditModal, setOpenEditModal] = useState(false);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [addNewItemModal, setAddNewItemModal] = useState(false);
    const [itemInputData, setItemInputData] = useState({
        isDefault: false,
        sequenceNumber: "",
        icon: "",
        value: "",
        mrp: "",
        offerPrice: "",
    });
    const [openAddonItemDeleteModal, setOpenAddonItemDeleteModal] = useState(false);
    const [selectedItemExcludedOutlets, setSelectedItemExcludedOutlets] = useState([]);
    const [addonItemId, setAddonItemId] = useState('');
    const [isItemDeleteBtnLoading, setIsItemDeleteBtnLoading] = useState(false);
    const [isAddItemLoading, setIsAddItemLoading] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [isSearchLoading, setIsSearchLoading] = useState(false);

    const outletData = outlets.map((outlet) => ({
        value: outlet._id,
        label: `${outlet.name} (${outlet.city})`,
    }));

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: "6px",
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
        }),
    };

    const columns = [ 
        {
            header: "Sr.No",
            accessor: "serialNumber",
            render: (value, row) => (
              <div className="text-center">
                {row?.serialNumber || "----"}
              </div>
            ),
        },
        {
            header: "Menu Name & Addons",
            render: (value, row) => (
                <div className="w-100">
                    {/* Product Category and Name */}
                    <div className="fs-5 fw-bold mt-3">
                        <span style={{ color: '#09A5F7' }}>{row?.product?.category?.name}</span> 
                        {" > "}
                        <span style={{ color: '#0E4961' }}>{row?.product?.name || "--------"}</span>
                    </div>

                    {/* Addons Table */}
                    {row?.addons?.map((addon, addonIndex) => (
                        <table key={addonIndex} className="table table-striped table-bordered mt-2 w-100">
                            <thead>
                                <tr>
                                    <th style={{ color: '#800080', fontWeight: '700', fontSize: '16px' }} className="text-center">
                                        {addon?.addonSerialNumber}
                                    </th>
                                    <th style={{ color: '#800080', fontWeight: '700', fontSize: '16px' }} className="text-center" colSpan={addon.addonTitle === "Size" || addon.addonTitle === "size" ? 7 : 6}>
                                        <span>{addon?.addonTitle?.toUpperCase()}{" "} {addon?.isMultipleSelect ? "(Can Select Multiple Addons)" : ""}</span>
                                        <br />
                                        {addon?.excludedOutletsDetails?.length > 0 && (
                                            <span className="text-muted" style={{ fontSize: '12px' }}>
                                                Excluded Outlets: {"[ "}
                                                {addon?.excludedOutletsDetails?.map(outlet => outlet?.name).join(", ")}
                                                {" ]"}
                                            </span>
                                        )}
                                    </th>
                                    <th className="text-end" style={{ width: '15%' }}>
                                        <button
                                            className="btn btn-sm btn-primary"
                                            onClick={() => {
                                                setAddNewItemModal(true);
                                                setProductAddonId(addon._id);
                                            }}
                                        >
                                            <i className="ri-add-line fw-semibold" style={{ fontSize: '15px' }}></i>
                                        </button>
                                    </th>
                                </tr>
                                <tr>
                                    <th className="text-center" >Seq. No.</th>
                                    <th className="text-center">Value</th>
                                    <th className="text-end" style={{ width: '10%' }}>MRP</th>
                                    <th className="text-end">Offer Price</th>
                                    <th className="text-end">Is Default</th>
                                    <th className="text-end" >Status</th>
                                    <th className="text-end" style={{ width: '15%' }}>Exc. Outlets</th>
                                    {(addon?.addonTitle === "Size" || addon?.addonTitle === 'size') && (
                                        <th className="text-end" style={{ width: '10%' }}>Sub Label</th>
                                    )}
                                    <th className="text-end">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {addon?.addonValues?.map((item, itemIndex) => (
                                    <tr key={itemIndex}>
                                        <td className="text-center">{item?.sequenceNumber}</td>
                                        <td className="text-center">{item?.value || 0}</td>
                                        <td className="text-end">{item?.mrp === null || item?.isDefault ? 0 : item?.mrp?.toFixed(2)}</td>
                                        <td className="text-end">{item?.offerPrice === null || item?.isDefault ? 0 : item?.offerPrice?.toFixed(2)}</td>
                                        <td className="text-end">{item?.isDefault ? "True" : "False"}</td>
                                        <td className="text-end">
                                            <span 
                                                className={`badge ${item?.status === "ACTIVE" ? 'bg-success' : 'bg-danger'}`}
                                            >
                                                {item?.status === "ACTIVE" ? "ACTIVE" : "INACTIVE"}
                                            </span>
                                        </td>
                                        <td className="text-end" style={{ fontSize: '10px', color: item?.excludedOutlets?.length === 0 ? 'green' : 'red', width: '140px' }}>
                                            {item?.excludedOutlets?.length > 0 ? (
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                                    {item.excludedOutlets.map((outlet, index) => (
                                                        <span key={index} style={{ display: 'inline-block', width: '60%', boxSizing: 'border-box' }}>
                                                            {outlet?.name},
                                                        </span>
                                                    ))}
                                                </div>
                                            ) : (
                                                "Available In All Outlets"
                                            )}
                                        </td>
                                        {(addon?.addonTitle === "Size" || addon?.addonTitle === 'size') && (
                                            <td className="text-end">{item?.subLabel}</td>
                                        )}
                                        <td className="text-center">
                                            <div className="d-flex justify-content-around align-items-center">
                                                <a
                                                    href="#"
                                                    className="text-primary"
                                                    style={{ cursor: "pointer", textDecoration: "none" }}
                                                    onClick={() =>
                                                        handleEditModal(
                                                            item,
                                                            addon?.addonTitle,
                                                            addon?._id,
                                                            row?.product?._id,
                                                            addon?.addonSerialNumber,
                                                            addon?.isMultipleSelect,
                                                            addon
                                                        )
                                                    }
                                                >
                                                    <PencilFill size={16} /> Edit 
                                                </a>
                                                <span>|</span>
                                                <a
                                                    href="#"
                                                    className="text-danger"
                                                    style={{ cursor: "pointer", textDecoration: "none" }}
                                                    onClick={() => handleOpenAddonItemDeleteModal(row, item?._id)}
                                                >
                                                    <TrashFill size={16} /> Delete
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ))}
                </div>
            ),
        },
        {
            header: "Actions",
            accessor: null,
            render: (_, row) => (
                <div className="d-flex justify-content-around align-items-center">
                    <a
                        href="#"
                        className="text-danger"
                        style={{ cursor: "pointer", textDecoration: "none" }}
                        onClick={() => handleDeleteModal(row)}
                    >
                        <i className="ri-delete-bin-line me-2"></i>Delete
                    </a>
                </div>
            )
        }
    ]

    const getProductsList = async () => {
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
          const response = await axios.get("product", { headers });
          if (response?.data?.status === true) {
            setProductsList(response?.data?.data?.products);
            setFilteredProducts(response?.data?.data?.products)
          }
        } catch (error) {
          if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        }
    };

    const getCategoryList = async () => {
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
          const response = await axios.get("masters/category/get", { headers });
    
          if (response?.data?.status === true) {
            setCategoryList(response?.data?.data?.categories);
          }
        } catch (error) {
          if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        }
    };

    const getIconsList = async () => {
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
          const response = await axios.get("product-addon/getAddonIcons", {
            headers,
          });
          if (response?.data?.status === true) {
            const addOnIcons = response?.data?.data?.addonIcons;
            setIconsList(addOnIcons);
          }
        } catch (error) {
          if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        }
    };

    const getOutlets = async () => {
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
          const response = await axios.get("outlet", { headers });
    
          if (response?.data?.status === true) {
            
            let filteredOutlets = response?.data?.data?.outlets?.filter((act) => act?.status === "ACTIVE");
            
            setOutlets(filteredOutlets);
          }
        } catch (error) {
          if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        }
    };

    const getAddonProductsList = async (categoryId, page = 1, limit = 10, productId, search) => {
        setIsProcessing(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            // Create params object conditionally
            const params = { page, limit };
    
            if (categoryId !== "all" && categoryId !== '') {
                params.categoryId = categoryId;  // Add categoryId only if selected
            }
    
            if (productId !== "all" && productId !== '') {
                params.productId = productId;  // Add categoryId only if selected
            }

            if (search) {
                params.search = search;  // Add Search Id search text is not empty
            }
    
            const response = await axios.get("product-addon", { headers, params });
            if (response?.data?.status === true) {
                response?.data?.data?.productAddons.forEach((item, index) => {
                item.serialNumber = index + 1 + (page - 1) * limit; // Calculate serial number based on page
                });
                setAddonProductsList(response?.data?.data?.productAddons);
                setFilteredData(response?.data?.data?.productAddons);
                setTotalRows(response?.data?.data?.totalItems);
                setTotalPages(response?.data?.data?.totalPages);
                console.log("Addon list response?.data?.data ", response?.data?.data);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
                });
            }
        } finally {
            setIsProcessing(false);
        }
    };

    const validateProcurementItem = (item) => {
        // const errors = {};
    
        // if (!item.value.trim()) {
        //   errors.value = "Value is required.";
        // }
    
        // if (item.mrp.trim() === "") {
        //   errors.mrp = "MRP is required.";
        // }
    
        // if (item.offerPrice.trim() === "") {
        //   errors.offerPrice = "Offer Price is required.";
        // }
        // if (!item.sequenceNumber.trim()) {
        //   errors.value = "Sequence Number is required.";
        // }
    
        // if (item.icon.trim() === "") {
        //   errors.mrp = "ICON is required.";
        // }
    
        // // if (item.offerPrice.trim() === "") {
        // //   errors.offerPrice = "Offer Price is required.";
        // // }
    
        // return errors;
    
        const errors = {};
        if (!item.value) errors.value = "Value is required";
        if (!item.sequenceNumber)
          errors.sequenceNumber = "Sequence Number is required";
        return errors;
    };

    const handleAddNewOpenModal = () => {
        setAddNewOpenModal(true);
    };

    const handleAddItem = () => {
        const addonValuesErrors = inputData.addonValues.map(
          validateProcurementItem
        );
        if (addonValuesErrors.some((errors) => Object.keys(errors).length > 0)) {
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            addonValues: addonValuesErrors,
          }));
          return;
        }
    
        setInputData((prevData) => ({
          ...prevData,
          addonValues: [
            ...prevData.addonValues,
            {
              value: "",
              mrp: "",
              offerPrice: "",
              sequenceNumber: "",
              icon: "",
              isDefault: false,
            },
          ],
        }));
    };
    
    const handleRemoveItem = (index) => {
        setInputData((prevData) => {
          const updatedItems = [...prevData.addonValues];
          updatedItems.splice(index, 1);
          return {
            ...prevData,
            addonValues: updatedItems,
          };
        });
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const handleChange = (e, index) => {
        const { name, value } = e.target;
    
        setValidationErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors };
    
          if (name === "value" || name === "sequenceNumber") {
            if (index !== undefined) {
              updatedErrors.addonValues = [...prevErrors.addonValues];
              updatedErrors.addonValues[index] = {
                ...prevErrors.addonValues[index],
                [name]: "",
              };
            }
          } else {
            updatedErrors[name] = "";
          }
    
          return updatedErrors;
        });
    
        if (index !== undefined) {
          setInputData((prevData) => {
            const updatedAddonValues = [...prevData.addonValues];
    
            // Check if there's already an item with isDefault set to true
            const isDefaultExists = updatedAddonValues.some(
              (item, i) => item.isDefault === "true" && i !== index
            );
    
            if (name === "isDefault" && value === "true" && isDefaultExists) {
              alert("Only one addon can be set as default.");
              return prevData;
            }
    
            updatedAddonValues[index] = {
              ...updatedAddonValues[index],
              [name]: value,
            };
    
            // If isDefault is set to true, clear mrp and offerPrice fields
            if (name === "isDefault" && value === "true") {
              updatedAddonValues[index].mrp = "";
              updatedAddonValues[index].offerPrice = "";
            }
    
            return {
              ...prevData,
              addonValues: updatedAddonValues,
            };
          });
        } else {
          setInputData((prevData) => ({
            ...prevData,
            [name]: value,
          }));
        }
    };

    const handleSelectChange = (selected) => {
        setSelectedExcludedOutlets(selected);
    };

    const handleSelectValueExChange = (selected, index) => {
        setSelectedValueExcludedOutlets((prev) => {
          const updatedValues = [...prev];
          updatedValues[index] = selected;
          return updatedValues;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
      
        // if (!isValidName(inputData?.addonTitle)) {
        //     toast.error("Addon Title must contain only characters", {
        //         position: "top-right",
        //         autoClose: 3000,
        //         theme: "colored",
        //     });
        //     return;
        // }
      
        setIsLoading(true);
      
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
    
            let selectedTitleExcOutlets = selectedExcludedOutlets?.map((ex) => ex?.value);
            let selectedValueExOutlets = selectedValueExcludedOutlets?.map((ex) => ex?.value);    
        
            const removeEmptyFields = (obj) => {
                return Object.fromEntries(
                Object.entries(obj).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
                );
            };
      
            // Function to check if an addonValue object is empty after cleaning
            const isEmptyAddonValue = (obj) => {
                return Object.keys(removeEmptyFields(obj)).length === 0;
            };
      
            // Add excludedOutlets to each addonValue if it's not empty
            const cleanedAddonValues = inputData.addonValues
                .map((addonValue) => {
                    const cleanedValue = removeEmptyFields(addonValue);
                    if (selectedValueExOutlets?.length > 0) {
                        cleanedValue.excludedOutlets = selectedValueExOutlets;
                    }
                    return cleanedValue;
                })
                .filter((value) => !isEmptyAddonValue(value));
      
            // Clean main inputData and add excludedOutlets if it's not empty
            const cleanedInputData = {
                ...removeEmptyFields(inputData),
                ...(selectedTitleExcOutlets?.length > 0 && { excludedOutlets: selectedTitleExcOutlets }),
                addonValues: cleanedAddonValues,
            };
      
            const response = await axios.post("product-addon", cleanedInputData, {
                headers,
            });
      
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
                });
                getAddonProductsList(categoryId, page, limit, productId, searchText);
        
                setInputData({
                    product: "",
                    addonTitle: "",
                    isMultipleSelect: "",
                    addonValues: Array.from({ length: 1 }, () => ({
                        value: "",
                        mrp: "",
                        offerPrice: "",
                        sequenceNumber: "",
                        icon: "",
                        isDefault: false,
                        subLabel: "",
                        status: "INACTIVE",
                    })),
                });
        
                setSelectedExcludedOutlets([]);
                setSelectedValueExcludedOutlets([]);
                setAddNewOpenModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                errorMessage =
                    error?.response?.data?.error?.message ||
                    error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                errorMessage =
                    error?.response?.data?.data?.message ||
                    error?.response?.data?.error;
                } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.error;
                }
        
                toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
                });
            }
            } finally {
            setIsLoading(false);
            }
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
        getAddonProductsList(categoryId, newPage, limit, productId, searchText); // Fetch new data for the current page
    };

    const handleRowsPerPageChange = (newLimit) => {
        setLimit(newLimit);
        getAddonProductsList(categoryId, page, newLimit, productId, searchText); // Fetch new data for the current rows per page
    };

    const handleEditModal = async (data, title, id, productId, addonSerialNumber, isMultipleSelect, exOutlets) => {
        setEditedData({
          _id: id,
          product: productId,
          addonTitle: title,
          addonSerialNumber: addonSerialNumber,
          value: data?.value,
          mrp: data?.mrp,
          offerPrice: data.offerPrice,
          addonId: data?._id,
          isDefault: data?.isDefault,
          sequenceNumber: data?.sequenceNumber,
          icon: data?.icon?._id,
          subLabel: data?.subLabel,
          status: data?.status,
          isMultipleSelect: isMultipleSelect,
        });
        setOpenEditModal(true);
        console.log("Edit Modal :", data);
        console.log("Edit Modal Excluled outlets for Addon :", exOutlets);
    
        let mappedExoutlets = exOutlets?.excludedOutletsDetails?.map((ex) => ({
          value: ex?._id,
          label: ex?.name,
        }));
        
        console.log("mappedExoutlets :", mappedExoutlets);
        
        setSelectedEditedExcludedOutlets(mappedExoutlets);
    
        let mappedAddonValueExoutlets = data?.excludedOutlets?.map((ex) => ({
          value: ex?._id,
          label: ex?.name,
        }));
        setSelectedEditedValueExcludedOutlets(mappedAddonValueExoutlets);
        
    };

    const handleEditedExSelectChange = (selected) => {
        setSelectedEditedExcludedOutlets(selected);
      };
    
    const handleEditedValueExSelectChange = (selected) => {
        setSelectedEditedValueExcludedOutlets(selected);
    };
    
    const handleEditChange = (e) => {
        const { name, value } = e.target;
    
        setEditedData((prevState) => {
          let updatedData = { ...prevState, [name]: value };
    
          if (name === "isDefault") {
            const isDefaultValue = value === "true";
            updatedData = { ...prevState, [name]: isDefaultValue };
    
            if (isDefaultValue) {
              updatedData = { ...updatedData, mrp: "", offerPrice: "" };
            }
          }
    
          return updatedData;
        });
    
        setEditValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        // if (Object.values(editValidationErrors).some((error) => error !== "")) {
        //   return;
        // }
        setIsEditBtnLoading(true);
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
    
          let selectedAddonOutlets = selectedEditedExcludedOutlets?.map((ex) => ex?.value);
          let selectedAddonValueOutlets = selectedEditedValueExcludedOutlets?.map((ex) => ex?.value);
    
          const data = {
            _id: editedData._id,
            addonTitle: editedData.addonTitle,
            addonSerialNumber: editedData?.addonSerialNumber,
            product: editedData?.product,
            isMultipleSelect: editedData?.isMultipleSelect,
            excludedOutlets: selectedAddonOutlets,
            addonValues: [
              {
                value: editedData.value,
                mrp: editedData.mrp ? editedData.mrp : null,
                offerPrice: editedData.offerPrice ? editedData.offerPrice : null,
                _id: editedData.addonId,
                isDefault: editedData?.isDefault,
                isMultipleSelect: editedData?.isMultipleSelect,
                sequenceNumber: editedData?.sequenceNumber,
                icon: editedData?.icon,
                subLabel: editedData?.subLabel,
                status: editedData?.status,
                excludedOutlets: selectedAddonValueOutlets
              },
            ],
          };
    
          // const cleanedData = {
          //   ...data,
          //   addonValues: data.addonValues.map((valueObj) =>
          //     Object.fromEntries(
          //       Object.entries(valueObj).filter(
          //         ([_, v]) => v !== "" && v !== null && v !== undefined
          //       )
          //     )
          //   ),
          // };
    
          const cleanedData = {
            ...data,
            addonValues: data.addonValues.map((valueObj) =>
              Object.fromEntries(
                Object.entries(valueObj).filter(
                  ([key, v]) =>
                    key === "mrp" || 
                    key === "offerPrice" || 
                    (key === "subLabel" ? v !== null : v !== "" && v !== undefined) // Exclude subLabel if null
                )
              )
            ),
          };      
    
          const response = await axios.put("product-addon", cleanedData, {
            headers,
          });
    
          if (response?.data?.status === true) {
            toast.success(response?.data?.data?.message, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            getAddonProductsList(categoryId, page, limit, productId, searchText);
            setOpenEditModal(false);
            setEditedData({});
          }
        } catch (error) {
          if (error?.response) {
            console.log("error?.response", error.response);
            
            let errorMessage = "";
            if (error.response?.status === 406) {
              errorMessage =
                error?.response?.data?.error?.message ||
                error?.response?.data?.error ||
                error?.response?.data?.message;
            } else if (error.response?.status === 412) {
              errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error
            } else if (error.response?.status === 500) {
              errorMessage = error?.response?.data?.error;
            }
    
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } finally {
          setIsEditBtnLoading(false);
        }
    };

    const handleDeleteModal = async (data, itemId) => {
        setOpenDeleteModal(true);
        setProductAddonId(data?._id);
    };

    const handleDeleteProductAddons = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
    
            const data = {
                _id: productAddonId,
            };
    
            const response = await axios.delete(`product-addon`, {
                data,
                headers,
            });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getAddonProductsList(categoryId, page, limit, productId, searchText);
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = '';
                // error.response.data.error
                if (error.response?.status === 406) {
                errorMessage =
                    error?.response?.data?.error?.message ||
                    error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                errorMessage = error?.response?.data?.data?.message ||
                    error?.response?.data?.error;
                } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.error;
                }
                toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    const handleItemChange = (e) => {
        const { name, value } = e.target;
        setItemInputData((prev) => ({ ...prev, [name]: value }));
    };
    
    const handleItemExSelectChange = (selected) => {
        setSelectedItemExcludedOutlets(selected);
    };

    const addNewAddonItem = async (e) => {
        e.preventDefault();
        setIsAddItemLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
    
            // Filter out empty or null values from itemInputData
            const filteredItemInputData = Object.fromEntries(
                Object.entries(itemInputData).filter(
                    ([key, value]) => value !== "" && value !== null
                )
            );
    
            let selectedExOutletsForItems = selectedItemExcludedOutlets?.map((se) => se?.value);
          
            const data = {
                addonId: productAddonId,
                addonItemData: {
                ...filteredItemInputData,
                ...(selectedExOutletsForItems?.length > 0 && { excludedOutlets: selectedExOutletsForItems })
                }
            };
          
            const response = await axios.post("product-addon/addAddonItem", data, {
                headers,
            });
    
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getAddonProductsList(categoryId, page, limit, productId, searchText);
                setProductAddonId("");
                setItemInputData({
                    value: "",
                    mrp: "",
                    offerPrice: "",
                });
                setAddNewItemModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                errorMessage =
                    error?.response?.data?.error?.message ||
                    error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.error;
                }
        
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
          setIsAddItemLoading(false);
        }
    };

    const handleOpenAddonItemDeleteModal = (data, itemId) => {
        setOpenAddonItemDeleteModal(true);
        setProductAddonId(data?._id);
        setAddonItemId(itemId);
    };
    
    const handleDeleteAddonItem = async (e) => {
        e.preventDefault();
        setIsItemDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
    
            const data = {
                addonId: productAddonId,
                addonItemId: addonItemId,
            };
    
            const response = await axios.delete(`product-addon/deleteAddonItem`, {
                data,
                headers,
            });
            if (response?.data?.status === true) {
                    toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getAddonProductsList(categoryId, page, limit, productId, searchText);
                setOpenAddonItemDeleteModal(false);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                    let errorMessage = error.response.data.error;
                    toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsItemDeleteBtnLoading(false);
        }
    };

    const handleSubmitSearch = () => {
        setIsSearchLoading(true);
        setIsClicked(true);
        getAddonProductsList(categoryId, page, limit, productId, searchText);
        setIsSearchLoading(false);
    }

    const addBtnDisable = !itemInputData.value?.trim() || !itemInputData?.sequenceNumber;

    useEffect(() => {
        getProductsList();
        getCategoryList();
        getIconsList();
        getOutlets();
    }, []);

    useEffect(() => {
        getAddonProductsList(categoryId, page, limit, productId, searchText);
    }, [categoryId, limit, page, productId]);

    useEffect(() => {
        if(searchText === "" && isClicked ) {
          getAddonProductsList();
        }
        // setFilteredData(result);
    }, [searchText]);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div
                    className="container shadow-sm"
                    style={{ backgroundColor: "white" }}
                >
                    <Row className="pt-4">
                        <Col>
                            <h5 className="fw-semibold">MENU ADDONS MANAGEMENT</h5>
                        </Col>
                        <hr />
                    </Row>
                    <Row className='mt-2'>
                        <Col lg="3">
                            <Form.Select 
                                value={categoryId} 
                                name='categoryFilter' 
                                onChange={(e) => {
                                    const selectedCategory = e.target.value;
                                    setCategoryId(selectedCategory);
                                    if (selectedCategory === 'all') {
                                        setFilteredProducts(productsList);
                                    } else {
                                        setFilteredProducts(
                                            productsList.filter((product) => product.category._id === selectedCategory)
                                        );
                                    }
                                }}
                            >
                                <option value="">Select Category</option>
                                {categoryList?.map((cat) => (
                                    <option key={cat?._id} value={cat._id}>
                                        {cat.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col lg="3">
                            <Select
                                options={filteredProducts?.map((rm) => ({
                                    value: rm?._id,
                                    label: rm?.name,
                                }))}
                                value={
                                    productId
                                        ? { value: productId, label: filteredProducts?.find((rm) => rm._id === productId)?.name }
                                        : null
                                }
                                onChange={(selectedOption) => {
                                    setProductId(selectedOption ? selectedOption?.value : '');
                                }}
                                classNamePrefix="react-select"
                                isClearable
                                placeholder="Select Menu"
                            />
                        </Col>
                        <Col lg="3">
                            <div className="input-group w-100">
                                <input
                                    type="text"
                                    value={searchText}
                                    onChange={handleSearchChange}
                                    className="form-control"
                                    placeholder="Search by addon title..."
                                />
                                <button className="btn btn-primary" type="button" onClick={handleSubmitSearch}>
                                    { isSearchLoading ? <Spinner size='sm' /> : <>  <i className="ri-search-line"></i> Search </> }
                                </button>
                            </div>
                        </Col>
                        <Col lg="3" className="d-flex justify-content-end flex-column">
                            <Button
                              variant="primary"
                              className="fw-semibold"
                              onClick={handleAddNewOpenModal}
                            >
                                <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                                  Add New Addon
                            </Button>
                        </Col>
                    </Row>

                {/* <------- Listing Of Addons ------> */}
                    <Row className='mt-4'>
                        <Col>
                            <ReusableTable
                                columns={columns}
                                rowKey="serialNumber"
                                loading={isProcessing}
                                data={filteredData}
                                isServerSidePagination={true}
                                totalPages={totalPages}
                                currentPage={page}
                                onPageChange={handlePageChange}
                                onRecordsPerPageChange={handleRowsPerPageChange}
                                recordsPerPage={limit}
                            />
                        </Col>
                    </Row>
                </div>

                {addNewOpenModal ? (
                    <Modal
                        size="lg"
                        centered
                        show={addNewOpenModal}
                        onHide={() => setAddNewOpenModal(false)}
                        aria-labelledby="add-menu-addon-modal"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="add-menu-addon-modal">ADD MENU ADDON</Modal.Title>
                        </Modal.Header>
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Select Menu <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Select
                                                options={productsList?.map((rm) => ({
                                                    value: rm?._id,
                                                    label: rm?.name,
                                                }))}
                                                value={
                                                    inputData.product
                                                    ? {
                                                        value: inputData?.product,
                                                        label: productsList?.find(
                                                            (rm) => rm._id === inputData?.product
                                                        )?.name,
                                                        }
                                                    : null
                                                }
                                                onChange={(selectedOption) => {
                                                    handleChange({
                                                    target: {
                                                        name: "product",
                                                        value: selectedOption ? selectedOption.value : "",
                                                    },
                                                    });
                                                }}
                                                classNamePrefix="react-select"
                                                isClearable
                                                placeholder="Select Menu"
                                            />
                                            {validationErrors.product && (
                                                <Form.Text className="text-danger">
                                                    {validationErrors.product}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Addon Title <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Addon Title"
                                                name="addonTitle"
                                                value={inputData?.addonTitle}
                                                onChange={handleChange}
                                            />
                                            {validationErrors.addonTitle && (
                                                <Form.Text className="text-danger">
                                                    {validationErrors.addonTitle}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Sequence No. <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="number"
                                                min={0}
                                                placeholder="Sequence No"
                                                name="addonSerialNumber"
                                                value={inputData?.addonSerialNumber}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Is It Multi-Select Addon{" "}
                                                <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                name="isMultipleSelect"
                                                onChange={handleChange}
                                                value={inputData?.isMultipleSelect}
                                            >
                                                <option value="" disabled>
                                                    Select
                                                </option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={12}>
                                        <Form.Label>Select Excluded Outlets</Form.Label>
                                        <Select
                                            isMulti
                                            value={selectedExcludedOutlets}
                                            onChange={handleSelectChange}
                                            options={outletData}
                                            placeholder="Select Excluded Outlets"
                                            closeMenuOnSelect={false}
                                        />
                                    </Col>
                                </Row>

                                <h6>ADDONS</h6>
                                <hr />

                                {inputData.addonValues &&
                                    inputData.addonValues.map((item, index) => (
                                <div key={index} className="mt-2">
                                    <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Is Default <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                name="isDefault"
                                                onChange={(e) => handleChange(e, index)}
                                                value={item.isDefault}
                                            >
                                                <option value="">Select</option>
                                                <option value="true">TRUE</option>
                                                <option value="false">FALSE</option>
                                            </Form.Select>
                                            {validationErrors.addonValues[index]?.isDefault && (
                                                <Form.Text className="text-danger">
                                                {validationErrors.addonValues[index]?.isDefault}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Addon MRP</Form.Label>
                                            <Form.Control
                                                type="number"
                                                min={0}
                                                step="0.01"
                                                placeholder="In Rupees"
                                                name="mrp"
                                                value={item.mrp}
                                                onChange={(e) => handleChange(e, index)}
                                                disabled={item.isDefault === "true"}
                                            />
                                            {validationErrors.addonValues[index]?.mrp && (
                                                <Form.Text className="text-danger">
                                                {validationErrors.addonValues[index]?.mrp}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Addon Offer Price</Form.Label>
                                            <Form.Control
                                                type="number"
                                                min={0}
                                                step="0.01"
                                                placeholder="In Rupees"
                                                name="offerPrice"
                                                value={item.offerPrice}
                                                onChange={(e) => handleChange(e, index)}
                                                disabled={item.isDefault === "true"}
                                            />
                                            {validationErrors.addonValues[index]?.offerPrice && (
                                                <Form.Text className="text-danger">
                                                {validationErrors.addonValues[index]?.offerPrice}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <div className="d-flex justify-content-end mt-4">
                                            {index === inputData.addonValues.length - 1 && (
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={handleAddItem}
                                                    className="me-2"
                                                >
                                                    <i className="ri-add-line fw-semibold" style={{ fontSize: '17px' }}></i>
                                                {/* <FaPlus /> */}
                                                </Button>
                                            )}
                                            {inputData?.addonValues?.length > 1 && (
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => handleRemoveItem(index)}
                                                >
                                                    <i className="ri-subtract-line fw-semibold" style={{ fontSize: '17px' }}></i>
                                                {/* <FaMinus /> */}
                                                </Button>
                                            )}
                                        </div>
                                    </Col>
                                    </Row>

                                    <Row>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Addon Value <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Addon Value"
                                                name="value"
                                                value={item.value}
                                                onChange={(e) => handleChange(e, index)}
                                            />
                                            {validationErrors.addonValues[index]?.value && (
                                                <Form.Text className="text-danger">
                                                {validationErrors.addonValues[index]?.value}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Sequence No. <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="number"
                                                min={0}
                                                placeholder="Sequence No."
                                                name="sequenceNumber"
                                                value={item.sequenceNumber}
                                                onChange={(e) => handleChange(e, index)}
                                            />
                                            {validationErrors.addonValues[index]?.sequenceNumber && (
                                                <Form.Text className="text-danger">
                                                {validationErrors.addonValues[index]?.sequenceNumber}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Select Addon Icon</Form.Label>
                                            <Form.Select
                                                name="icon"
                                                onChange={(e) => handleChange(e, index)}
                                                value={item.icon}
                                            >
                                                <option value="">Select Addon Icon</option>
                                                {iconsList?.map((rm) => (
                                                <option key={rm._id} value={rm._id}>
                                                    {rm.name}
                                                </option>
                                                ))}
                                            </Form.Select>
                                            {validationErrors.addonValues[index]?.icon && (
                                                <Form.Text className="text-danger">
                                                {validationErrors.addonValues[index]?.icon}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    </Row>

                                    {(inputData.addonTitle === "Size" ||
                                    inputData.addonTitle === "size") && (
                                        <Row>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Weight (20mg, 20ml, ...)</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Weight (20mg, 20ml, ...)"
                                                        name="subLabel"
                                                        value={item.subLabel}
                                                        onChange={(e) => handleChange(e, index)}
                                                    />
                                                    {validationErrors.addonValues[index]?.subLabel && (
                                                    <Form.Text className="text-danger">
                                                        {validationErrors.addonValues[index]?.subLabel}
                                                    </Form.Text>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    )}

                                    <Row>
                                        <Col md={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    Select Excluded Outlets For Values
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    value={selectedValueExcludedOutlets?.[index] || []}
                                                    onChange={(selected) =>
                                                        handleSelectValueExChange(selected, index)
                                                    }
                                                    options={outletData}
                                                    placeholder="Select Excluded Outlets For Values"
                                                    closeMenuOnSelect={false}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                                ))}
                            </Modal.Body>
                                <Modal.Footer>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    // disabled={btnDisable()}
                                    className="w-100"
                                >
                                    {isLoading ? <Spinner size='sm' /> : "ADD PRODUCT ADDON"}
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                ) : null }

                {openEditModal ? (
                    <Modal
                        size="xl"
                        centered
                        show={openEditModal}
                        onHide={() => {
                        setEditedData({});
                        setOpenEditModal(false);
                        }}
                        aria-labelledby="vertically-centered-modal"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="vertically-centered-modal" className="fs-6">
                                EDIT MENU ADDON
                            </Modal.Title>
                        </Modal.Header>
                        <Form onSubmit={handleEditSubmit}>
                            <Modal.Body>
                                {/* Main Addon Section */}
                                <div className="main-addon-section mb-4 p-3 bg-light rounded">
                                    <h6 className="fw-bold mb-3">MAIN ADDON DETAILS</h6>
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                Addon Title <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Addon Title"
                                                    name="addonTitle"
                                                    value={editedData?.addonTitle || ""}
                                                    onChange={handleEditChange}
                                                />
                                                <div className="text-danger">
                                                    {editValidationErrors.addonTitle}
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Select Menu <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Select
                                                    options={productsList?.map((rm) => ({
                                                        value: rm?._id,
                                                        label: rm?.name,
                                                    }))}
                                                    value={
                                                        editedData?.product
                                                        ? productsList
                                                            .map((rm) => ({ value: rm?._id, label: rm?.name }))
                                                            .find((option) => option.value === editedData?.product)
                                                        : null
                                                    }
                                                    onChange={(selectedOption) => {
                                                        if (selectedOption) {
                                                        handleEditChange({
                                                            target: {
                                                            name: "product",
                                                            value: selectedOption.value,
                                                            },
                                                        });
                                                        } else {
                                                        handleEditChange({
                                                            target: {
                                                            name: "product",
                                                            value: "",
                                                            },
                                                        });
                                                        }
                                                    }}
                                                    classNamePrefix="react-select"
                                                    isClearable
                                                    placeholder="Select Menu"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Addon Seq No. <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Sequence No."
                                                    name="addonSerialNumber"
                                                    value={editedData.addonSerialNumber || ""}
                                                    onChange={handleEditChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Is It Multi-Select Addon <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    size="sm"
                                                    name="isMultipleSelect"
                                                    onChange={handleEditChange}
                                                    value={editedData?.isMultipleSelect || ""}
                                                >
                                                    <option>Select</option>
                                                    <option value="true">Yes</option>
                                                    <option value="false">No</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                        
                                    <Row className="mb-3">
                                        <Col md={12}>
                                            <Form.Label className="fw-semibold">
                                                Select Excluded Outlets For Addon
                                            </Form.Label>
                                            <Select
                                                isMulti
                                                components={animatedComponents}
                                                value={selectedEditedExcludedOutlets}
                                                onChange={handleEditedExSelectChange}
                                                options={outletData}
                                                styles={customStyles}
                                                placeholder="Select Excluded Outlets For Addon"
                                                closeMenuOnSelect={false}
                                                theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 0,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: "#e9ecef",
                                                    primary: "#007bff",
                                                },
                                                })}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                    
                                {/* Addon Value Section */}
                                <div className="addon-value-section p-3 bg-light rounded">
                                    <h6 className="fw-bold mb-3">ADDON VALUE DETAILS</h6>
                                    <Row>
                                        <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                            Is Default <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                            name="isDefault"
                                            onChange={handleEditChange}
                                            value={editedData?.isDefault || ""}
                                            >
                                            <option>Is Default</option>
                                            <option value="true">TRUE</option>
                                            <option value="false">FALSE</option>
                                            </Form.Select>
                                        </Form.Group>
                                        </Col>
                                        <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Addon MRP</Form.Label>
                                            <Form.Control
                                            min={0}
                                            step="0.01"
                                            type="number"
                                            placeholder="In Rupees"
                                            name="mrp"
                                            value={editedData?.mrp || ""}
                                            onChange={handleEditChange}
                                            disabled={editedData?.isDefault === true}
                                            />
                                        </Form.Group>
                                        </Col>
                                        <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                            Addon Offer Price
                                            </Form.Label>
                                            <Form.Control
                                            min={0}
                                            step="0.01"
                                            type="number"
                                            placeholder="Addon Offer Price"
                                            name="offerPrice"
                                            value={editedData?.offerPrice || ""}
                                            onChange={handleEditChange}
                                            disabled={editedData?.isDefault === true}
                                            />
                                        </Form.Group>
                                        </Col>
                                        <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Select Status</Form.Label>
                                            <Form.Select
                                            size="sm"
                                            name="status"
                                            onChange={handleEditChange}
                                            value={editedData?.status || ""}
                                            >
                                            <option value="">Select Status</option>
                                            <option value="ACTIVE">ACTIVE</option>
                                            <option value="INACTIVE">INACTIVE</option>
                                            </Form.Select>
                                        </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Addon Value <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Addon Value"
                                                name="value"
                                                value={editedData.value || ""}
                                                onChange={handleEditChange}
                                            />
                                        </Form.Group>
                                        </Col>
                                        <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Sequence No. <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Sequence No."
                                                name="sequenceNumber"
                                                value={editedData.sequenceNumber || ""}
                                                onChange={handleEditChange}
                                            />
                                        </Form.Group>
                                        </Col>
                                        <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Select Addon Icon
                                            </Form.Label>
                                            <Form.Select
                                                name="icon"
                                                onChange={handleEditChange}
                                                value={editedData.icon || ""}
                                            >
                                            <option value="">Select Addon Icon</option>
                                            {iconsList.map((rm) => (
                                                <option key={rm._id} value={rm._id}>
                                                {rm.name}
                                                </option>
                                            ))}
                                            </Form.Select>
                                        </Form.Group>
                                        </Col>
                                        {(editedData.addonTitle === "Size" || editedData.addonTitle === "size") && (
                                        <Col md={3}>
                                            <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold">Sub Label</Form.Label>
                                            <Form.Control
                                                min={0}
                                                type="text"
                                                placeholder="Sub Label"
                                                name="subLabel"
                                                value={editedData.subLabel || ""}
                                                onChange={handleEditChange}
                                            />
                                            </Form.Group>
                                        </Col>
                                        )}
                                        <Col md={12}>
                                        <Form.Label className="fw-semibold">
                                            Select Excluded Outlets For Addon Value
                                        </Form.Label>
                                        <Select
                                            isMulti
                                            components={animatedComponents}
                                            value={selectedEditedValueExcludedOutlets}
                                            onChange={handleEditedValueExSelectChange}
                                            options={outletData}
                                            styles={customStyles}
                                            placeholder="Select Excluded Outlets For Addon Value"
                                            closeMenuOnSelect={false}
                                            theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 0,
                                            colors: {
                                                ...theme.colors,
                                                primary25: "#e9ecef",
                                                primary: "#007bff",
                                            },
                                            })}
                                        />
                                        </Col>
                                    </Row>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" type="submit" disabled={isEditBtnLoading}>
                                    {isEditBtnLoading ? "Saving..." : "SAVE CHANGES"}
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                ) : null }

                {/* <---------------- Delete Outlet Modal ------------> */}
                {openDeleteModal && (
                    <Modal show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Delete</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to delete this Addon? This action cannot be undone.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setOpenDeleteModal(false)}>
                                Cancel
                            </Button>
                            <Button variant="danger" onClick={handleDeleteProductAddons}>
                                { isDeleteBtnLoading ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> :
                                    "Delete Addon"                                
                                }
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}

                {addNewItemModal ? (
                        <Modal
                            size="xl"
                            centered
                            show={addNewItemModal}
                            onHide={() => {
                                setItemInputData({});
                                setSelectedItemExcludedOutlets([]);
                                setAddNewItemModal(false);
                            }}
                            aria-labelledby="VerticallyCenteredExample"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title className="fs-6">ADD ADDON ITEM</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={addNewAddonItem}>
                                <Modal.Body>
                                    <Row>
                                        <Col>
                                        <div className="mb-3">
                                            <Form.Label className="fw-semibold">
                                            Is Default <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                            onChange={handleItemChange}
                                            value={itemInputData.isDefault || ''}
                                            name="isDefault"
                                            >
                                            <option>Is Default</option>
                                            <option value="true">TRUE</option>
                                            <option value="false">FALSE</option>
                                            </Form.Select>
                                        </div>
                                        </Col>
                                        <Col>
                                        <div className="mb-3">
                                            <Form.Label className="fw-semibold">Addon MRP</Form.Label>
                                            <Form.Control
                                            min={0}
                                            type="number"
                                            placeholder="In Rupees"
                                            className="no-arrows"
                                            name="mrp"
                                            value={itemInputData.mrp || ''}
                                            onChange={handleItemChange}
                                            disabled={itemInputData?.isDefault === "true"}
                                            />
                                        </div>
                                        </Col>
                                        <Col>
                                        <div className="mb-3">
                                            <Form.Label className="fw-semibold">
                                            Addon Offer Price
                                            </Form.Label>
                                            <Form.Control
                                            min={0}
                                            type="number"
                                            placeholder="In Rupees"
                                            className="no-arrows"
                                            name="offerPrice"
                                            value={itemInputData.offerPrice || ''}
                                            onChange={handleItemChange}
                                            disabled={itemInputData?.isDefault === "true"}
                                            />
                                        </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                        <div className="mb-3">
                                            <Form.Label className="fw-semibold">
                                            Addon Value <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                            type="text"
                                            placeholder="Addon Value"
                                            name="value"
                                            value={itemInputData.value || ''}
                                            onChange={handleItemChange}
                                            />
                                        </div>
                                        </Col>
                                        <Col>
                                        <div className="mb-3">
                                            <Form.Label className="fw-semibold">
                                            Sequence No. <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                            type="number"
                                            placeholder="Sequence No"
                                            className="no-arrows"
                                            name="sequenceNumber"
                                            value={itemInputData.sequenceNumber || ''}
                                            onChange={handleItemChange}
                                            />
                                        </div>
                                        </Col>
                                        <Col>
                                        <div className="mb-3">
                                            <Form.Label className="fw-semibold">Select Icon</Form.Label>
                                            <Form.Select>
                                            <option>Select Icon</option>
                                            {iconsList.map((rm) => (
                                                <option key={rm._id} value={rm._id}>
                                                {rm.name}
                                                </option>
                                            ))}
                                            </Form.Select>
                                        </div>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col className="col-md-12">
                                        <Form.Label className="fw-semibold">
                                            Select Excluded Outlets For Addon Value
                                        </Form.Label>
                                        <Select
                                            isMulti
                                            components={animatedComponents}
                                            value={selectedItemExcludedOutlets}
                                            onChange={handleItemExSelectChange}
                                            options={outletData}
                                            styles={customStyles}
                                            placeholder="Select Excluded Outlets For Addon Value"
                                            closeMenuOnSelect={false}
                                            theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 0,
                                            colors: {
                                                ...theme.colors,
                                                primary25: "#e9ecef",
                                                primary: "#007bff",
                                            },
                                            })}
                                        />
                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        disabled={addBtnDisable}
                                    >
                                        { isAddItemLoading ? <Spinner size='sm'/> : "ADD ADDON ITEM" }
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                ) : null}

                {openAddonItemDeleteModal ? (
                    <Modal show={openAddonItemDeleteModal} onHide={() => setOpenAddonItemDeleteModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Delete</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to delete this Addon Value? This action cannot be undone.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setOpenDeleteModal(false)}>
                                Cancel
                            </Button>
                            <Button variant="danger" onClick={handleDeleteAddonItem}>
                                { isItemDeleteBtnLoading ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> :
                                    "Delete Addon Value"                                
                                }
                            </Button>
                        </Modal.Footer>
                    </Modal>

                ) : null}
            </div>
        </React.Fragment>
    )
}

export default MenuAddons